'use client';

import AIChatbotPage from '@/views/products/ai-chatbot';

export default AIChatbotPage;
